import { AuthxTesting } from "./AuthxTesting";
import { EndpointTesting } from "./EndpointTesting";
import { EquityOrderTicketDemo } from "./EquityOrderTicketDemo";
import { ErrorTesting } from "./ErrorTesting";
import { IconTesting } from "./IconTesting";
import { TradingViewConfig } from "./TradingViewConfig";

export const Devtools = () => {
  return (
    <div className="flex flex-col gap-4 pr-2">
      <h1 className="m-0 font-bold text-2xl">Devtools</h1>

      <ErrorTesting />
      <EquityOrderTicketDemo />
      <IconTesting />
      <TradingViewConfig />
      <EndpointTesting />
      <AuthxTesting />
    </div>
  );
};
